import React from 'react';

import {
  Box,
  Button,
  Stack,
  Typography,
  styled
} from '@mui/material';

import { FormModal } from 'modules/layer00';
import { ResponsiveImage } from 'iron-forge-react-modules';

import img1x from 'assets/images/returnAuthorizationIllustration/1x.png';
import img2x from 'assets/images/returnAuthorizationIllustration/2x.png';
import img3x from 'assets/images/returnAuthorizationIllustration/3x.png';



const PrimaryTextTypography = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  color: '#3A3B3D',
  letterSpacing: '0.16px',
  lineHeight: '140%',
  marginBottom: theme.spacing(1)
}));

const SecondaryTextTypography = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  color: '#89898B',
  marginBottom: theme.spacing(4)
}));

const ChildBox = styled(Box)({
  flex: 1
});



export interface IOverrideButtonArgs {
  label?: string;
  onClick?: () => void;
}

export interface IProps {
  title: string;
  primaryText: string;
  secondaryText: string;

  children: JSX.Element | JSX.Element[];

  disableButtons?: boolean;

  overrideCloseButtonArgs?: IOverrideButtonArgs;
  overrideSubmitButtonArgs?: IOverrideButtonArgs;

  onSubmit?: (e?: React.BaseSyntheticEvent) => Promise<void>;
  onClose: () => void;
  onBack?: () => void;
}

export const FC: React.FC<IProps> = props => {
  return (
    <FormModal.FC
      isDoubleWide
      title={props.title}
      onSubmit={props.onSubmit}
      onClose={props.onClose}
      fnGenElCloseButton={args => (
        <Button
          disabled={props.disableButtons}
          variant="outlined"
          color="info"
          onClick={props.onBack}>
          {props.overrideCloseButtonArgs?.label ?? args.cancelButtonLabel ?? "Cancel"}
        </Button>
      )}
      fnGenElAcceptButton={args => (
        <Button
          disabled={props.disableButtons}
          variant="contained"
          type="submit">
          {props.overrideSubmitButtonArgs?.label ?? args.acceptButtonLabel ?? "Finish"}
        </Button>
      )}>
      <Stack
        spacing={5}
        direction="row"
        alignItems="center">
        <Box sx={{ maxWidth: 320 }}>
          <PrimaryTextTypography>
            {props.primaryText}
          </PrimaryTextTypography>

          <SecondaryTextTypography>
            {props.secondaryText}
          </SecondaryTextTypography>

          <ResponsiveImage.FC urlSet={[
            img1x,
            img2x,
            img3x
          ]} />
        </Box>

        <ChildBox>
          {props.children}
        </ChildBox>
      </Stack>
    </FormModal.FC>
  );
};
